/**
 * Corpus-wide publication/review dates for public /docs and /learn guides.
 * Keep in sync with `backend/constants/guideSeoDates.js`.
 */
export const GUIDE_DATE_PUBLISHED = '2025-09-01';
export const GUIDE_DATE_MODIFIED = '2026-08-21';

export function formatGuideBylineDate(isoDate) {
  if (!isoDate) return '';
  const d = new Date(isoDate);
  if (Number.isNaN(d.getTime())) return '';
  return d.toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' });
}
